<template>
  <div>
    <div class="wrapper wrapper-content">
      <div class="row animated fadeInUp">
        <div class="col-lg-12">
          <filebox-list
            :icons="icons"
            :myFiles="myFiles"
            :companyFiles="companyFiles"
            :loadingMyFiles="loadingMyFiles"
            :loadingCompanyFiles="loadingCompanyFiles"
          ></filebox-list>
        </div>
<!--        <div class="col-lg-4">-->
<!--          <filebox-stats :numCompanyFiles="companyFiles.length" :numMyFiles="myFiles.length"></filebox-stats>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import FileboxList from '@/components/filebox/FileboxList';
import FileboxStats from '@/components/filebox/FileboxStats';

export default {
  name: 'FileboxDashboard',
  components: {
    FileboxList,
    FileboxStats,
  },
  props: {
    myFiles: {
      type: Array,
      default: () => [],
      required: true,
    },
    companyFiles: {
      type: Array,
      default: () => [],
      required: true,
    },
    loadingMyFiles: {
      type: Boolean,
      default: false,
    },
    loadingCompanyFiles: {
      type: Boolean,
      default: false,
    },
    icons: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// FileboxDashboard.vue?56c6c058